import { X, UserX } from "lucide-react";
import { createPortal } from "react-dom";

export default function AbsentPreviewModal({ isOpen, onClose, users, onLeaveUserIds = new Set() }) {
  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 bg-black/50 z-[9999] flex items-center justify-center px-4">
      <div className="
        w-full max-w-md
        rounded-2xl
        bg-white/15 backdrop-blur-xl
        border border-white/20
        shadow-2xl
        text-white
      ">

        {/* Header */}
        <div className="
          flex justify-between items-center
          px-5 py-4
          rounded-t-2xl
          bg-gradient-to-r from-[#2d1c6a] to-[#24155a]
        ">
          <div className="flex items-center gap-2">
            <UserX size={18} />
            <h2 className="font-semibold">
              Absent Employees ({users.length})
            </h2>
          </div>
          <X onClick={onClose} className="cursor-pointer hover:text-red-300" />
        </div>

        {/* Body */}
        <div className="p-5 space-y-2 max-h-[60vh] overflow-y-auto">
          {users.map(u => (
            <div
              key={u.user_id}
              className="px-4 py-2 rounded-lg bg-white/10 flex items-center justify-between gap-3"
            >
              <span className="text-sm">{u.name}</span>
              {onLeaveUserIds.has(Number(u.user_id)) && (
                <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-green-500/20 text-green-300 border border-green-500/30 whitespace-nowrap flex items-center gap-1">
                  🟢 On Leave
                </span>
              )}
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="p-4 flex justify-end border-t border-white/20">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg bg-purple-600 hover:bg-purple-500"
          >
            Close
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
